import { UserActionType } from '@store/branches/user/enums';

export const fetchCurrentUserPermissions = (dispatch, userId, errorCB, successCB = () => {}) => {
	dispatch({
		type: UserActionType.FETCH_USER_PERMISSIONS,
		payload: {
			userId,
			successCB,
			errorCB: message => {
				errorCB(message);
		}
		}
	});
};
